import React from "react";
import { Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment";
const H2HBattleList = (props) => {
  return (
    <>
      <Modal
        show={props.isModalOpen}
        onHide={() => props.setIsModalOpen(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            H2H-Round {props?.roundDetails.round} (
            {moment(props?.roundDetails.start_date).format("MMM D")}-
            {moment(props?.roundDetails.end_date).format("MMM D")})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="roundinfomodal"
            style={{ maxHeight: "400px", overflowY: "auto" }}
          >
            {props.h2hBattleData &&
              props.h2hBattleData.map((item, key) => (
                <div className="chain-cols">
                  <div className="rount-point">
                    <span className="point-count">{++key}</span>
                    <ul className="tabslist">
                      <li key={item.id}>
                        {item?.fo_image && (
                          <img
                            src={`${process.env.REACT_APP_USER_PROFILE}/${item?.fo_image}`}
                            alt="img"
                          />
                        )}
                        {!item?.fo_image && (
                          <img src={`../images/user-img.png`} alt="img" />
                        )}
                        <span className="name-fs">{item?.first_opponent}</span>{" "}
                        {item.total_points_first_member >
                        item.total_points_second_member ? (
                          <span className="rankcount winnerPlayer">
                            {item.total_points_first_member}
                          </span>
                        ) : (
                          <span className="rankcount orange">
                            {item.total_points_first_member}
                          </span>
                        )}
                      </li>
                      <li>
                        {item?.so_image && (
                          <img
                            src={`${process.env.REACT_APP_USER_PROFILE}/$item?.so_image}`}
                            alt="img"
                          />
                        )}
                        {!item?.so_image && (
                          <img src={`../images/user-img.png`} alt="img" />
                        )}
                        <span className="name-fs">{item?.second_opponent}</span>{" "}
                        {item.total_points_second_member >
                        item.total_points_first_member ? (
                          <span className="rankcount winnerPlayer">
                            {item.total_points_second_member}
                          </span>
                        ) : (
                          <span className="rankcount orange">
                            {item.total_points_second_member}
                          </span>
                        )}
                      </li>
                    </ul>
                  </div>
                </div>
              ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="poweredby">
            Powered By
            <img src="images/logo.png" alt="img" />
          </div>

          <div className="">
            <Link
              className="border-btn"
              onClick={() => props.setIsModalOpen(false)}
            >
              Close
            </Link>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default H2HBattleList;
